import { Device } from "@services/devices/types";

export const getIsDevicePaused = (device: Device) => {
  const monitored = device?.status?.pauseMonitoringStatus;
  
  return (
    monitored?.paused || monitored?.parentPaused || monitored?.outOfSchedule
  );
};
